import { CarouselTest } from "@dustin-web/microsite-components/src/carousel-test/carousel"
import { ListItemRenderer } from "@dustin-web/product-components/src/product-list"
import type { SearchPageQuery } from "@productsite/src/graphql/generated/graphql-types"

type Props = {
  title: string
  list: SearchPageQuery['searchPage']['secondaryList']
}

const SearchSecondaryList = ({ title, list }: Props) => {
  return (
    <section>
      <h2 className='u-mb-16'>{title}</h2>
      <CarouselTest
        dots
        partialVisible
        fullWidth
        type='default'
        dotMode='full-width'
        colorTheme='gray'
        list={list?.map(
          (entry, key) =>
            entry?.searchResultProduct && (
              // Remove product type casting once E3 is removed
              <ListItemRenderer
                key={entry.ticket + key}
                product={entry.searchResultProduct as any}
                ticket={entry.ticket}
                digitalIndex={key}
                listType='stripped'
                gallerySizeClasses='slider-card u-px-8'
                digitalDataOrigin='searchPageList'
              />
            )
        )}
      />
    </section>
  )
}

export default SearchSecondaryList
